import React from 'react';
import { Icon } from './index';

const certificateCollection = Icon(
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 800 800"
  >
    <g>
      <path
        fill="#f74d93"
        d="M483.02655,18.65216c.0105-.00889,.0198-.01858,.0299-.02747l-.27633,.22462c-.0101,.00929-.0202,.01899-.0303,.02788l.27674-.22503Z"
      />
      <path
        fill="#0095f8"
        d="M299.45078,731.73894c-.162-.4444-.33936-.89203-.51308-1.33925,.17331,.44682,.35107,.89485,.51308,1.33925Z"
      />
      <path
        fill="#0095f8"
        d="M300.21393,733.94799c-.20483-.62822-.42541-1.26007-.65326-1.89313,.22745,.63306,.44844,1.26532,.65326,1.89313Z"
      />
      <path
        fill="#0095f8"
        d="M300.8773,736.10574c-.19917-.69124-.41369-1.38652-.64034-2.08422,.22664,.69811,.44076,1.39298,.64034,2.08422Z"
      />
      <path
        fill="#df0093"
        d="M707.10621,136.50485c-1.6838-8.24959-6.57667-15.49286-13.60049-20.13719L543.90488,17.54235c-20.4075-13.9835-42.04763-13.33477-55.80412-3.01746l-5.06124,4.08803c-.08808,.07674-.17215,.15875-.25942,.2364l.27638-.22472c-.01008,.00893-.01936,.01867-.02989,.02749l-.27672,.22506L155.4671,285.11071c14.56729-11.87466,36.66191-13.75649,58.69147,.68115l161.18343,106.45033c7.08246,4.67869,15.4695,6.97904,23.94735,6.56373,8.4774-.41531,16.60146-3.5205,23.19428-8.8674l134.40772-109.36276,139.11264-113.10856c2.50113-2.03611,4.68797-4.43026,6.48859-7.10514,4.63952-7.02668,6.30075-15.60763,4.61363-23.85721Z"
      />
      <path
        fill="#0095f8"
        d="M297.2183,726.05389l1.35218,3.39398c.12928,.31875,.24401,.63428,.36723,.95182-.11029-.28482-.2121-.56802-.32724-.85365l-1.39217-3.49215Z"
      />
      <path
        fill="#0095f8"
        d="M300.96658,736.43338c-.03111-.10948-.05737-.21775-.08928-.32764,.03192,.10989,.05818,.21816,.08928,.32764Z"
      />
      <path
        fill="#0095f8"
        d="M300.23696,734.02152c-.00808-.02464-.01495-.04888-.02303-.07353,.00808,.02464,.01495,.04888,.02303,.07353Z"
      />
      <path
        fill="#0095f8"
        d="M299.56067,732.05486c-.03798-.10585-.0711-.21008-.10989-.31593,.03878,.10585,.07191,.21008,.10989,.31593Z"
      />
      <g>
        <path
          fill="none"
          d="M301.18596,765.27668c.12599-.40683,.24648-.81687,.36079-1.23012,.00699-.0252,.01386-.05028,.02085-.07548-.27111,.98616-.57291,1.95456-.9077,2.90223,.1875-.52481,.35804-1.06015,.52606-1.59664Z"
        />
        <path
          fill="none"
          d="M297.21831,726.05386l1.35221,3.39394c.1292,.31875,.24396,.6343,.3672,.95191-.1103-.28485-.21212-.5681-.32723-.85375l-1.39219-3.4921Z"
        />
        <path
          fill="none"
          d="M301.611,763.81383c.24912-.91984,.46616-1.85789,.65778-2.80946-.19551,.97104-.41794,1.92776-.67324,2.86558,.00515-.01867,.01031-.03745,.01546-.05612Z"
        />
        <path
          fill="#0095f8"
          d="M628.47192,460.35564l-71.58058-179.77988-134.40772,109.36276c-6.59282,5.3469-14.71688,8.45209-23.19428,8.8674-8.47786,.41531-16.86489-1.88504-23.94735-6.56373l-161.18343-106.45033c-22.02956-14.43764-44.12417-12.55581-58.69147-.68115l-.0977,.07628c-14.17833,11.51799-20.86163,33.12743-10.93386,57.33078l82.24768,206.62466-122.75514,99.86439c-2.47937,2.03771-4.64399,4.43187-6.42399,7.10549-4.63746,7.02061-6.29629,15.59594-4.61089,23.83992,1.68552,8.24386,6.57667,15.48232,13.59774,20.12219l125.72186,83.12194c20.95899,13.69189,41.78821,12.03719,55.15528,2.04424l.81115-.68149c.01214-.00974,.02348-.01981,.03516-.02955l1.83132-1.48828,188.90853-153.51763,138.90063-112.87834c-.51507,.41897-1.0456,.82019-1.58404,1.21248l1.68907-1.37363c13.75649-11.22581,20.05037-32.44423,10.51202-56.12849Zm-329.9014,269.09215l-1.35221-3.39394,1.39219,3.4921c.11511,.28565,.21693,.5689,.32723,.85375-.12324-.31761-.23801-.63316-.3672-.95191Zm2.97622,34.59877c-.11431,.41325-.2348,.82329-.36079,1.23012-.16802,.53649-.33857,1.07183-.52606,1.59664,.33479-.94767,.63659-1.91608,.9077-2.90223-.00699,.0252-.01386,.05028-.02085,.07548Zm.06425-.23274c-.00515,.01867-.01031,.03745-.01546,.05612,.2553-.93782,.47773-1.89454,.67324-2.86558-.19162,.95157-.40867,1.88962-.65778,2.80946Z"
        />
      </g>
    </g>
    <g>
      <path
        fill="#00b8fa"
        d="M628.47189,460.35566l-71.58057-179.77981-134.40774,109.36276c-6.59282,5.3469-14.7168,8.45202-23.19427,8.86733-8.47787,.41531-16.86485-1.88505-23.94732-6.56374l-161.18344-106.45034c-22.02954-14.43764-44.12413-12.55582-58.69145-.68114l-.09777,.07636c-14.17827,11.51795-20.86159,33.12734-10.93377,57.33079l82.2477,206.6246,.03878-.03151-.04727-.11837,150.24845-122.05553c6.59929-5.36306,14.73619-8.47787,23.22699-8.89278,8.4908-.41531,16.89394,1.89475,23.97964,6.58919l136.65557,90.84395c20.42204,13.6151,41.68197,12.43826,55.48533,2.38035l1.68911-1.37359c13.7565-11.22586,20.05036-32.44418,10.512-56.1285Z"
      />
      <path
        fill="#f74d93"
        d="M483.02655,18.65216c.0105-.00889,.0198-.01858,.0299-.02747l-.27633,.22462c-.0101,.00929-.0202,.01899-.0303,.02788l.27674-.22503Z"
      />
      <path
        fill="#0095f8"
        d="M299.45078,731.73894c-.162-.4444-.33936-.89203-.51308-1.33925,.17331,.44682,.35107,.89485,.51308,1.33925Z"
      />
      <path
        fill="#0095f8"
        d="M300.21393,733.94799c-.20483-.62822-.42541-1.26007-.65326-1.89313,.22745,.63306,.44844,1.26532,.65326,1.89313Z"
      />
      <path
        fill="#0095f8"
        d="M300.8773,736.10574c-.19917-.69124-.41369-1.38652-.64034-2.08422,.22664,.69811,.44076,1.39298,.64034,2.08422Z"
      />
      <path
        fill="#df0093"
        d="M556.86708,280.51525l-3.81656-9.60139-78.38185-197.14562c-9.49797-22.53777-4.61364-43.56904,8.08115-54.89105L155.46711,285.11071c14.56732-11.87468,36.66191-13.7565,58.69145,.68114l161.18344,106.45034c7.08247,4.67869,15.46944,6.97905,23.94732,6.56374,8.47747-.41531,16.60144-3.52043,23.19427-8.86733l134.40774-109.36276-.02424-.0606Z"
      />
      <path
        fill="#ff4f98"
        d="M707.10624,136.50491c-1.68386-8.24962-6.57666-15.49288-13.60055-20.13722L543.90484,17.54238c-20.4075-13.98354-42.04759-13.33472-55.80409-3.01745l-5.06127,4.08804c-.08807,.07676-.1721,.15877-.25937,.23634l.27633-.22462c-.0101,.00889-.01939,.01858-.0299,.02747l-.27674,.22503c-12.69479,11.32201-17.57912,32.35328-8.08115,54.89105l78.38185,197.14562,3.79959,9.55695,.04121,.10504,139.11268-113.10862c2.50114-2.03614,4.68798-4.43023,6.48859-7.10509,4.6395-7.02672,6.30074-15.60761,4.61364-23.85723Z"
      />
      <path
        fill="#0095f8"
        d="M297.2183,726.05389l1.35218,3.39398c.12928,.31875,.24401,.63428,.36723,.95182-.11029-.28482-.2121-.56802-.32724-.85365l-1.39217-3.49215Z"
      />
      <path
        fill="#0095f8"
        d="M300.96658,736.43338c-.03111-.10948-.05737-.21775-.08928-.32764,.03192,.10989,.05818,.21816,.08928,.32764Z"
      />
      <path
        fill="#0095f8"
        d="M300.23696,734.02152c-.00808-.02464-.01495-.04888-.02303-.07353,.00808,.02464,.01495,.04888,.02303,.07353Z"
      />
      <path
        fill="#0095f8"
        d="M299.56067,732.05486c-.03798-.10585-.0711-.21008-.10989-.31593,.03878,.10585,.07191,.21008,.10989,.31593Z"
      />
      <path
        fill="#0095f8"
        d="M301.92688,740.27701c-.06464-.29936-.13978-.60236-.20967-.90334-.08848-.38622-.17331-.77083-.27068-1.15866-.14867-.59105-.31148-1.18533-.47995-1.78163-.03111-.10948-.05737-.21775-.08928-.32764-.19957-.69124-.41369-1.38611-.64034-2.08422-.00808-.02464-.01495-.04888-.02303-.07353-.20483-.62781-.42581-1.26007-.65326-1.89313-.03798-.10585-.0711-.21008-.10989-.31593-.162-.4444-.33976-.89243-.51308-1.33925-.12322-.31754-.23795-.63306-.36723-.95182l-1.35218-3.39398-70.50392-176.83347-.03111-.07797-122.75525,99.86439c-2.47933,2.03776-4.64394,4.43185-6.42395,7.1055-4.63748,7.02066-6.29629,15.59589-4.61082,23.83985,1.68547,8.24396,6.57666,15.48237,13.59773,20.12228l125.7218,83.12195c20.95895,13.69186,41.78822,12.03709,55.15527,2.04422l.81123-.68154c.01212-.0097,.02343-.0198,.03515-.02949l1.83132-1.48832c4.68838-4.30943,8.36031-9.78844,10.61421-16.16795,2.72779-7.72078,3.38347-16.75133,1.26693-26.59633Z"
      />
      <path
        fill="#0095f8"
        d="M616.27078,517.85775c-13.80336,10.05791-35.06329,11.23475-55.48533-2.38035l-136.65557-90.84395c-7.0857-4.69444-15.48884-7.0045-23.97964-6.58919-8.4908,.4149-16.6277,3.52972-23.22699,8.89278l-150.24845,122.05553,.04727,.11837-.03878,.03151,.03111,.07797,70.50392,176.83347,1.39217,3.49215c.11514,.28563,.21695,.56883,.32724,.85365,.17372,.44722,.35107,.89485,.51308,1.33925,.03878,.10585,.07191,.21008,.10989,.31593,.22785,.63306,.44844,1.26491,.65326,1.89313,.00808,.02464,.01495,.04888,.02303,.07353,.22664,.6977,.44116,1.39298,.64034,2.08422,.03192,.10989,.05818,.21816,.08928,.32764,.16806,.5963,.33168,1.19098,.47995,1.78163,.09777,.38824,.1818,.77244,.27068,1.15866,.06949,.30098,.14544,.60398,.20967,.90334,1.84303,8.57241,1.58246,16.5263-.31593,23.53686l-.06424,.2327c-.11433,.41329-.23472,.82335-.36077,1.23017-.16806,.53651-.33855,1.0718-.526,1.5966-2.2539,6.37951-5.92583,11.85852-10.61421,16.16795l188.90853-153.5176,138.90058-112.87834c-.5151,.41894-1.04554,.82011-1.58407,1.21239Z"
      />
    </g>
  </svg>,
);

export default certificateCollection;
